import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import Icon from '@/components/renewal/common/icon.vue';
import { useTelemetry } from '@/plugins/telemetry';
import { WANDH_GUIDE_URL } from '@/constants';
import { ref, onMounted } from 'vue';
import { useRepositories } from '@/plugins/repositories';
export default /*#__PURE__*/_defineComponent({
  __name: 'search-footer',
  props: {
    type: null,
    isKeywordAskable: {
      type: Boolean
    }
  },
  emits: ['filterReset', 'changeShowFilter', 'submit', 'showDisclaimer'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var telemetry = useTelemetry();
    var route = useRoute();
    var repositories = useRepositories();
    var getGuideUrl = ref(WANDH_GUIDE_URL);
    var isWandhAskable = inject('isWandhAskable');
    var historyId = ref(null);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, firstItem;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return repositories.labs.listLabsWandhQuestionHistories(1, 1);
          case 3:
            res = _context.sent;
            if (res.length > 0) {
              firstItem = Array.isArray(res[0]) ? res[0][0] : res[0];
              if (firstItem) {
                historyId.value = firstItem.id;
              }
            }
            _context.next = 16;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0 instanceof Error)) {
              _context.next = 14;
              break;
            }
            telemetry.sendErrorTelemetry(_context.t0, route);
            throw _context.t0;
          case 14:
            telemetry.sendErrorTelemetry(new Error(String(_context.t0)), route);
            throw new Error(String(_context.t0));
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    })));
    var handleFilterReset = function handleFilterReset() {
      emit('filterReset');
    };
    var handleClickHistory = function handleClickHistory() {
      telemetry.sendClickTelemetry({
        button: 'labs-wandh__history'
      }, route);
    };
    var handleClickGuide = function handleClickGuide() {
      telemetry.sendClickTelemetry({
        button: 'labs-wandh__guide'
      }, route);
    };
    var handleClickDisclaimer = function handleClickDisclaimer() {
      emit('showDisclaimer');
      telemetry.sendClickTelemetry({
        button: 'labs-wandh__disclaimer'
      }, route);
    };
    var handleClickFilterClose = function handleClickFilterClose() {
      emit('changeShowFilter', false);
    };
    var handleClickSubmit = function handleClickSubmit() {
      emit('submit');
    };
    var isSubmitDisabled = computed(function () {
      if (props.type === 'wandh') {
        return !isWandhAskable.value;
      } else {
        return !props.isKeywordAskable;
      }
    });
    return {
      __sfc: true,
      props: props,
      telemetry: telemetry,
      route: route,
      repositories: repositories,
      getGuideUrl: getGuideUrl,
      isWandhAskable: isWandhAskable,
      historyId: historyId,
      emit: emit,
      handleFilterReset: handleFilterReset,
      handleClickHistory: handleClickHistory,
      handleClickGuide: handleClickGuide,
      handleClickDisclaimer: handleClickDisclaimer,
      handleClickFilterClose: handleClickFilterClose,
      handleClickSubmit: handleClickSubmit,
      isSubmitDisabled: isSubmitDisabled,
      Icon: Icon
    };
  }
});